import m from "mithril";

import globalState from "../../../state";

import css from "./index.css";

const i18n = globalState.i18n.twostep.signup.sms.verify;

const dragonSrc = globalState.theme === "darkmode" ? "https://account.staticwars.com/img/dragon-dm.jpg" : "https://account.staticwars.com/img/dragon.jpg";

export default {
    view() {
        return globalState.needsMini ?
            m("div", { class : css.miniContent },
                m("a", {
                    class : css.miniDragon,
                    href  : "https://wiki.guildwars2.com/wiki/Mini_Mystical_Dragon"
                },
                    m("img", { src : dragonSrc, alt : "" }),

                    m("div", i18n.dragon)
                )
            ) :
            null;
    }
};
